"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageViews = exports.usePagesViews = void 0;
var usePagesViews_1 = require("./usePagesViews");
Object.defineProperty(exports, "usePagesViews", { enumerable: true, get: function () { return usePagesViews_1.usePagesViews; } });
var usePageViews_1 = require("./usePageViews");
Object.defineProperty(exports, "usePageViews", { enumerable: true, get: function () { return usePageViews_1.usePageViews; } });
//# sourceMappingURL=index.js.map